import { AttentionTriangleIcon, AlertsTabIcon } from '@rsos/assets/icons';
import { getIsTrainIncident } from '@rsos/base-utils';
import { ACTIVE_ASSAILANT } from '@rsos/constants/alertEmergencyTypes';
import {
  ACTIVE_ASSAILANT_ALERT_TYPE,
  LAW_ENFORCEMENT_ALERT_TYPE,
  FIRE_ALERT_TYPE,
  MEDICAL_ALERT_TYPE,
  TRAIN_INCIDENT_ALERT_TYPE,
  TEST_MODE_ALERT_TYPE,
} from '@rsos/constants/alertTypes';
import { NOTIFIED_AGENCY } from '@rsos/constants/alertsRoutingConstants';
import mapEmergencyTypeToAlertType from '@rsos/utils/mapEmergencyTypeToAlertType';

/**
 * Function to get the proper display icon for AlertToast.
 *
 * @param {string} emergencyName - alert emergency name
 * @returns React component
 */

export const getIconByEmergencyType = emergencyName => {
  if (
    getIsTrainIncident(emergencyName, true) ||
    emergencyName === ACTIVE_ASSAILANT
  ) {
    return <AttentionTriangleIcon width={12} height={12} />;
  }
  return <AlertsTabIcon width={14} height={16} color="states" />;
};

/**
 * Function to get diplay name for an alert type in Alert Toast
 *
 * @param {string} emergencyType - full emergency type
 * @returns string
 */
export const getAlertTypeDisplayName = emergencyType => {
  const mapper = {
    [ACTIVE_ASSAILANT_ALERT_TYPE]: 'Active Assailant',
    [FIRE_ALERT_TYPE]: 'Fire',
    [LAW_ENFORCEMENT_ALERT_TYPE]: 'Police',
    [TRAIN_INCIDENT_ALERT_TYPE]: 'Train Derailment',
    [MEDICAL_ALERT_TYPE]: 'EMS',
    [TEST_MODE_ALERT_TYPE]: emergencyType?.display_name,
  };
  return mapper[mapEmergencyTypeToAlertType(emergencyType?.name)];
};
/**
 * Function to get Accept button label
 *
 * @param {string} emergencyName - alert emergency name
 * @returns string
 */
export const getButtonLabel = emergencyName => {
  return emergencyName.startsWith('TEST') ? 'Accept Test' : 'Accept';
};
/**
 * Function to return bth style based on emergency type
 *
 * @param {string} emergencyName - alert emergency name
 * @returns string
 */
export const getButtonType = emergencyName => {
  if (
    getIsTrainIncident(emergencyName, true) ||
    emergencyName === ACTIVE_ASSAILANT
  ) {
    return 'tertiary';
  }
  return 'primary';
};

/**
 * Function to return text for the alert toast
 *
 * @param {object} alert - full alert object
 * @returns string
 */

export const getAlertToastTextContent = alert => {
  const {
    location = {},
    emergency_type: emergencyType,
    associated_role_type: roleType,
  } = alert;
  const { civic = {} } = location;
  const { street_1, street_2, city, state, zip_code } = civic;

  /** present only if it is a Notified Agency */
  const prependRoleType =
    roleType === NOTIFIED_AGENCY ? `Information Only: ` : '';

  /** always present */
  const alertTypeDisplayName = `New ${getAlertTypeDisplayName(
    emergencyType,
  )} Alert`;

  /** present if there is a civic address */
  const address = !street_1
    ? ''
    : ` at ${street_1}${street_2 ? `, ${street_2}` : ''} ${city}${
        state ? `, ${state}` : ''
      } ${zip_code}`;

  /** concatenate everything and return trimmed */
  const alertToastTextContent =
    prependRoleType + alertTypeDisplayName + address;
  return alertToastTextContent.trim();
};
